import React, { PropsWithChildren } from "react";
import { Box, SxProps, Typography } from "@mui/material";
import { palettes } from "common/theming";

type ConstellationType = {
  player:
    | "player1"
    | "player2"
    | "player3"
    | "player4"
    | "player1Lvl"
    | "player2Lvl"
    | "player3Lvl"
    | "player4Lvl";
  // Un badge de niveau suit la constellation : pas d'arrondi de son côté, les deux font un bloc.
  joined?: boolean;
};

const player1Colors = {
  bgcolor: palettes.dark.common?.player1?.bgConstel,
  borderColor: palettes.dark.common?.player1?.borderConstel,
};
const player2Colors = {
  bgcolor: palettes.dark.common?.player2?.bgConstel,
  borderColor: palettes.dark.common?.player2?.borderConstel,
};

const player1Props: SxProps = {
  top: "-1px",
  left: "-1px",
  borderBottomRightRadius: "0.7rem",
  ...player1Colors,
};
// Les badges de niveau ne s'arrondissent que vers l'extérieur : ils prolongent la constellation.
const player1LvlProps: SxProps = {
  top: "-1px",
  left: "29px",
  borderBottomRightRadius: "0.7rem",
  ...player1Colors,
};
const player2Props: SxProps = {
  top: "-1px",
  right: "-1px",
  borderBottomLeftRadius: "0.7rem",
  ...player2Colors,
};
const player2LvlProps: SxProps = {
  top: "-1px",
  right: "29px",
  borderBottomLeftRadius: "0.7rem",
  ...player2Colors,
};
const player3Props: SxProps = {
  top: "29px",
  left: "-1px",
  borderTopRightRadius: "0.7rem",
  borderBottomRightRadius: "0.7rem",
  ...player1Colors,
};
const player4Props: SxProps = {
  top: "29px",
  right: "-1px",
  borderTopLeftRadius: "0.7rem",
  borderBottomLeftRadius: "0.7rem",
  ...player2Colors,
};
const player3LvlProps: SxProps = {
  top: "29px",
  left: "29px",
  borderTopRightRadius: "0.7rem",
  borderBottomRightRadius: "0.7rem",
  ...player1Colors,
};
const player4LvlProps: SxProps = {
  top: "29px",
  right: "29px",
  borderTopLeftRadius: "0.7rem",
  borderBottomLeftRadius: "0.7rem",
  ...player2Colors,
};

const Constellation = (props: PropsWithChildren<ConstellationType>) => {
  const { player, joined = false } = props;
  const isLeftSide = player === "player1" || player === "player3";

  const getProps = () => {
    switch (player) {
      case "player1":
        return player1Props;
      case "player1Lvl":
        return player1LvlProps;
      case "player2":
        return player2Props;
      case "player2Lvl":
        return player2LvlProps;
      case "player3":
        return player3Props;
      case "player4":
        return player4Props;
      case "player3Lvl":
        return player3LvlProps;
      case "player4Lvl":
        return player4LvlProps;
    }
  };

  return (
    <Box
      component="div"
      sx={{
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        top: "-1px",
        zIndex: 1,
        left: player === "player1" ? "-1px" : "unset",
        right: player === "player2" ? "-1px" : "unset",
        borderBottomRightRadius: player === "player1" ? "0.7rem" : "unset",
        borderBottomLeftRadius: player === "player2" ? "0.7rem" : "unset",
        width: 30,
        height: 30,
        color: "white",
        border: "1px solid",
        ...getProps(),
        ...(joined &&
          (isLeftSide
            ? { borderTopRightRadius: 0, borderBottomRightRadius: 0 }
            : { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 })),
      }}
    >
      <Typography>{props.children}</Typography>
    </Box>
  );
};

export default Constellation;
